"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconFurnitureFilled = function IconFurnitureFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.5 25C31.6326 25 31.7598 24.9473 31.8536 24.8536C31.9473 24.7598 32 24.6326 32 24.5V20C32 19.7348 31.8946 19.4804 31.7071 19.2929C31.5196 19.1054 31.2652 19 31 19H6C5.73478 19 5.48043 19.1054 5.29289 19.2929C5.10536 19.4804 5 19.7348 5 20V24.5C5 24.6326 5.05268 24.7598 5.14645 24.8536C5.24021 24.9473 5.36739 25 5.5 25H8C8.79565 25 9.55871 25.3161 10.1213 25.8787C10.6839 26.4413 11 27.2044 11 28V31.5C11 31.6326 11.0527 31.7598 11.1464 31.8536C11.2402 31.9473 11.3674 32 11.5 32H25.5C25.6326 32 25.7598 31.9473 25.8536 31.8536C25.9473 31.7598 26 31.6326 26 31.5V28C26 27.2044 26.3161 26.4413 26.8787 25.8787C27.4413 25.3161 28.2044 25 29 25H31.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 27H4C3.73478 27 3.48043 27.1054 3.29289 27.2929C3.10536 27.4804 3 27.7348 3 28V43C3 43.2652 3.10536 43.5196 3.29289 43.7071C3.48043 43.8946 3.73478 44 4 44H8C8.26522 44 8.51957 43.8946 8.70711 43.7071C8.89464 43.5196 9 43.2652 9 43V28C9 27.7348 8.89464 27.4804 8.70711 27.2929C8.51957 27.1054 8.26522 27 8 27Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33 27H29C28.7348 27 28.4804 27.1054 28.2929 27.2929C28.1054 27.4804 28 27.7348 28 28V43C28 43.2652 28.1054 43.5196 28.2929 43.7071C28.4804 43.8946 28.7348 44 29 44H33C33.2652 44 33.5196 43.8946 33.7071 43.7071C33.8946 43.5196 34 43.2652 34 43V28C34 27.7348 33.8946 27.4804 33.7071 27.2929C33.5196 27.1054 33.2652 27 33 27Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.5 34H11.5C11.2239 34 11 34.2239 11 34.5V37.5C11 37.7761 11.2239 38 11.5 38H25.5C25.7761 38 26 37.7761 26 37.5V34.5C26 34.2239 25.7761 34 25.5 34Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48 17.93L44.32 6.56C44.2686 6.39648 44.166 6.2538 44.0274 6.15298C43.8887 6.05216 43.7214 5.99853 43.55 6H38.45C38.2786 5.99853 38.1112 6.05216 37.9726 6.15298C37.834 6.2538 37.7314 6.39648 37.68 6.56L34 17.93C33.9594 18.0562 33.95 18.1903 33.9727 18.3208C33.9953 18.4514 34.0492 18.5746 34.1298 18.6797C34.2104 18.7849 34.3153 18.869 34.4355 18.9248C34.5557 18.9805 34.6876 19.0064 34.82 19H39V41H37C36.7348 41 36.4804 41.1054 36.2929 41.2929C36.1053 41.4804 36 41.7348 36 42V43C36 43.2652 36.1053 43.5196 36.2929 43.7071C36.4804 43.8946 36.7348 44 37 44H45C45.2652 44 45.5195 43.8946 45.7071 43.7071C45.8946 43.5196 46 43.2652 46 43V42C46 41.7348 45.8946 41.4804 45.7071 41.2929C45.5195 41.1054 45.2652 41 45 41H43V19H47.18C47.3123 19.0064 47.4443 18.9805 47.5645 18.9248C47.6847 18.869 47.7896 18.7849 47.8702 18.6797C47.9508 18.5746 48.0047 18.4514 48.0273 18.3208C48.0499 18.1903 48.0405 18.0562 48 17.93Z",
    fill: color
  }));
};

IconFurnitureFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconFurnitureFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconFurnitureFilled;
exports.default = _default;